import React from 'react';

const Contact = () => {
  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <h2>Contact</h2>
        <p className="section-subtitle">
          Interested in working together or want to know more about my learning projects?
        </p>
        <div className="contact-box">
          <p>Email me at:</p>
          <p>
            <a href="mailto:pavant.dev@gmail.com">pavant.dev@gmail.com</a>
          </p>
          <p>Or connect on:</p>
          <div className="social-links">
            <a
              href="https://github.com/pavantdev-lab"
              target="_blank"
              rel="noopener noreferrer"
            >
              GitHub
            </a>
            <a
              href="https://www.linkedin.com/in/pavantayade"
              target="_blank"
              rel="noopener noreferrer"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
